import type { FC } from 'react'
import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import LinkedProfilesImage from './LinkedProfilesImage'

const copy = {
  heading: `Enable any data in the warehouse to be activated in real time with Linked Profiles`,
  description: `Linked Profiles helps data teams map a Data Graph that brings together the power of the Segment real time customer data platform with the complete set of business records stored in data warehouses and lakes— promoting a deeper understanding of each customer, the buying groups they are associated with and their interactions with your business.`,
  buttonText: `Sign up for the Beta`,
  buttonUrl: `/linked-profiles-beta/`,
}

const LinkedProfiles: FC = () => {
  const pageConfig = usePageConfig()

  return (
    <StyledSectionBase variant="2Col">
      <Section.Contents>
        <LinkedProfilesImage alt={`Illustration: ${copy.heading}`} />
      </Section.Contents>
      <StyledCopy alignSelf="center">
        <CopyTextBase>
          <CopyText.Heading tag="h2" variant="h2">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description tag="p" variant="pLarge">
            {copy.description}
          </CopyText.Description>
          <CopyText.Link href={getAbsoluteUrl(copy.buttonUrl, pageConfig)}>{copy.buttonText}</CopyText.Link>
        </CopyTextBase>
      </StyledCopy>
    </StyledSectionBase>
  )
}

export default LinkedProfiles

const StyledSectionBase = styled(SectionBase)`
  overflow: visible;
`

const StyledCopy = styled(Section.Copy)`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 440px;
    justify-self: end;
    align-self: center;
  }
`
